import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import Typography from '@material-ui/core/Typography';
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import Conf from '../../../config/config.js';

const styles = theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    padding: '30px 10px 16px 10px',
  },
  card: {
    margin: '10px 20px 10px 20px',
  },

  typographyHead: {
    margin: '20px 0 0 20px',
    fontSize: '1.0em'
  },
  typography: {
    margin: '10px 0 0 16px',
    fontSize: '0.8em'
  },
});

const ExPanelSummary = withStyles(theme => ({
  root: {
    padding: '5px 5px 5px 10px !important',
    height: '18px',
    backgroundColor: "#c6e2ff",
    minHeight: "50px",
    '&$expanded': {
      minHeight: "50px",
    },
  },
  expanded: {
    padding: "12px 0 12px 0px"
  },
  expandIcon: {
    padding: "0",
  }
}))(ExpansionPanelSummary);

const ExPanel = withStyles(theme => ({
  expanded: {
    margin: "0"
  }
}))(ExpansionPanel);

const ExPanelDetail = withStyles(theme => ({
  root: {
    padding: "10px",
    display: "block"
  }
}))(ExpansionPanelDetails);


class Help extends React.Component {

  render() {
    const { classes } = this.props;
    return (
      <div>
        <Typography className={classes.typographyHead}>防護管取付に係る流れについて</Typography>
        <Card className={classes.card}>
          <ExPanel>
            <ExPanelSummary expandIcon={<ExpandMoreIcon />} >
              <Typography>①お申込み</Typography>
            </ExPanelSummary>
            <ExPanelDetail>
              <Typography>■取付申込メニュー画面から[防護管取付の新規申込はこちら]を選択し，取付申込画面にて必要事項を入力してください。</Typography>
              <Typography>■取付希望範囲の写真撮影方法については，<a target="_blank" rel="noopener noreferrer" href={Conf.ATTACHED_EXAMPLE_URL}>こちら</a>を参考にしてください。</Typography>
              <Typography>■[登録]をクリックすると申込が完了します。</Typography>
            </ExPanelDetail>
          </ExPanel>
          <ExPanel >
            <ExPanelSummary expandIcon={<ExpandMoreIcon />} >
              <Typography>②取付範囲の確認</Typography>
            </ExPanelSummary>
            <ExPanelDetail>
              <Typography>■①でお申込みいただいた内容について，配電サポートセンターの担当者より電話連絡いたします。</Typography>
            </ExPanelDetail>
          </ExPanel>
          <ExPanel >
            <ExPanelSummary expandIcon={<ExpandMoreIcon />}>
              <Typography>③取付内容の確認</Typography>
            </ExPanelSummary>
            <ExPanelDetail>
              <Typography>■②で調整した結果の確認について，メールがお客さま宛に送信されます。</Typography>
              <Typography>■メール本文に記載されたURLから取付内容確認画面へアクセスし，取付内容についてご確認をお願いします。</Typography>
              <Typography>■内容に問題がなければ，お見積金額確認画面，ご請求金額確認画面の内容をご確認いただき，画面下部の[承諾]をクリックしてください。この操作を以て，取付作業実施が確定します。</Typography>
            </ExPanelDetail>
          </ExPanel>
          <ExPanel >
            <ExPanelSummary expandIcon={<ExpandMoreIcon />}>
              <Typography>④取付作業の実施</Typography>
            </ExPanelSummary>
            <ExPanelDetail>
              <Typography>■防護管取付予定日が決まり次第，メールがお客さま宛に送信されます。</Typography>
              <Typography>■防護管取付作業が完了しましたら，メールがお客さま宛に送信されます。</Typography>
            </ExPanelDetail>
          </ExPanel>
          <ExPanel >
            <ExPanelSummary expandIcon={<ExpandMoreIcon />}>
              <Typography>⑤撤去作業の実施</Typography>
            </ExPanelSummary>
            <ExPanelDetail>
              <Typography>■防護管取付期間満了日の１ヶ月前になりましたら，メールがお客さま宛に送信されます。</Typography>
              <Typography>■メール本文に記載されたURLから撤去確認画面へアクセスし，撤去予定日についてご確認をお願いします。撤去予定日の変更がある場合にも，こちらから承ります。</Typography>
              <Typography>■撤去予定日について間違いがないことを確認し，画面下部の[確認]をクリックしてください。この操作を以て撤去作業実施が確定します。</Typography>
              <Typography>■防護管撤去作業が完了しましたら，メールがお客さま宛に送信されます。</Typography>
            </ExPanelDetail>
          </ExPanel>
        </Card>
        
        <Typography className={classes.typographyHead}>高圧・特別高圧引込線切離・接続（開閉器操作）サービスの流れについて</Typography>
        <Card className={classes.card}>
          <ExPanel>
            <ExPanelSummary expandIcon={<ExpandMoreIcon />} >
              <Typography>①お申込み</Typography>
            </ExPanelSummary>
            <ExPanelDetail>
              <Typography>■申込メニューの画面から[引込線切離サービスの新規申込はこちら]を選択し，申込画面にて申込書（PDF形式）を添付してください。</Typography>
              <Typography>■申込書は，こちらからダウンロードしてください。</Typography>
              <Typography>■お客様の受電柱および沖縄電力の引込柱の写真撮影方法については，こちらを参考にしてください。</Typography>
              <Typography>■[登録]をクリックすると申し込みが完了します。</Typography>
            </ExPanelDetail>
          </ExPanel>
          <ExPanel >
            <ExPanelSummary expandIcon={<ExpandMoreIcon />} >
              <Typography>②申込内容の確認</Typography>
            </ExPanelSummary>
            <ExPanelDetail>
              <Typography>■①でお申込みいただいた内容について，配電サポートセンターの担当者より電話連絡いたします。</Typography>
            </ExPanelDetail>
          </ExPanel>
          <ExPanel >
            <ExPanelSummary expandIcon={<ExpandMoreIcon />}>
              <Typography>③当社作業内容の確認</Typography>
            </ExPanelSummary>
            <ExPanelDetail>
              <Typography>■②で調整した結果について，メールがお客様宛に送信されます。</Typography>
              <Typography>■メール本文に記載されたURLから作業内容確認画面へアクセスし，作業内容についてご確認をお願いします。</Typography>
              <Typography>■内容に問題がなければ，お見積金額確認画面の内容をご確認いただき，画面下部の[承諾]をクリックしてください。この操作を以て，作業実施が確定します。</Typography>
            </ExPanelDetail>
          </ExPanel>
          <ExPanel >
            <ExPanelSummary expandIcon={<ExpandMoreIcon />}>
              <Typography>④当社作業の実施</Typography>
            </ExPanelSummary>
            <ExPanelDetail>
              <Typography>■作業が完了しましたら，メールがお客さま宛に送信されます。</Typography>
              <Typography>■メール本文に記載されたURLからご請求金額内容確認画面へアクセスし，ご請求内容についてご確認をお願いします。</Typography>
              <Typography>■内容に問題がなければ，ご請求金額確認画面の内容をご確認いただき，画面下部の[承諾]をクリックしてください。この操作を以て，ご請求金額が確定します。</Typography>
            </ExPanelDetail>
          </ExPanel>
        </Card>
        <div align="center">
          <a target="_blank" rel="noopener noreferrer" href={Conf.MANUAL_PDF_URL}>防護管取付・引込線切離申込操作説明書を表示する</a>
        </div>
      </div>
    );
  }
}

export default withStyles(styles)(Help);
